import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 94793E49-C5C4-47A8-87FD-215A923ACA2A
 * name message-bookmark-outline
 * version: 5.5.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/message-bookmark-outline.svg
 * tags
 */
export const MessageBookmarkOutlineIcon = createSvgIcon(<><path d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2M20 16H5.2L4 17.2V4H20V16M18 14V6H13V14L15.5 12.5L18 14" /></>, 'MessageBookmarkOutlineIcon');
export default MessageBookmarkOutlineIcon